export default __webpack_public_path__ + "static/media/exit.a03f9dc7.svg";